import { SOCIAL_AD_TYPES } from "utils/constants";

import { getFacebookImageFields } from "./FacebookImageMO";
import { getFacebookVideoFields } from "./FacebookVideoMO";
import { FACEBOOK_CAROUSEL_FIELDS } from "social/carousel/FacebookMOMainContent";
import { FACEBOOK_CAROUSEL_MO_FIELDS } from "social/carousel/FacebookCarouselCardForm";

import { LINKEDIN_IMAGE_FIELDS } from "./LinkedInImage";
import { LINKEDIN_VIDEO_FIELDS } from "./LinkedInVideo";
import { LINKEDIN_CAROUSEL_MAIN_FIELDS } from "./LinkedInCarousel";
import { LINKEDIN_CAROUSEL_FIELDS } from "social/carousel/LinkedInCarouselCardForm";

import { PINTEREST_IMAGE_FIELDS } from "./PinterestImage";
import { PINTEREST_VIDEO_FIELDS } from "./PinterestVideo";
import { PINTEREST_VIDEO_FIELDS as PINTEREST_MAX_VIDEO_FIELDS } from "./PinterestMaxWidthVideo";
import { PINTEREST_CAROUSEL_FIELDS } from "social/carousel/PinterestCarouselCardForm";

import { SNAPCHAT_IMAGE_FIELDS } from "./SnapchatImage";
import { SNAPCHAT_VIDEO_FIELDS } from "./SnapchatVideo";

import { TIKTOK_VIDEO_FIELDS } from "./TikTokVideo";


const FIELDS_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: getFacebookImageFields(""),
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: getFacebookVideoFields(""),
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]:{
		...FACEBOOK_CAROUSEL_FIELDS,
		...FACEBOOK_CAROUSEL_MO_FIELDS,
	},

	[SOCIAL_AD_TYPES.LINKEDIN_IMAGE]:    LINKEDIN_IMAGE_FIELDS,
	[SOCIAL_AD_TYPES.LINKEDIN_VIDEO]:    LINKEDIN_VIDEO_FIELDS,
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]:{
		...LINKEDIN_CAROUSEL_FIELDS,
		...LINKEDIN_CAROUSEL_MAIN_FIELDS,
	},

	[SOCIAL_AD_TYPES.PINTEREST_IMAGE]: PINTEREST_IMAGE_FIELDS,
	[SOCIAL_AD_TYPES.PINTEREST_VIDEO]: PINTEREST_VIDEO_FIELDS,
	[SOCIAL_AD_TYPES.PINTEREST_MAX_WIDTH_VIDEO]: PINTEREST_MAX_VIDEO_FIELDS,
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]:{
		...PINTEREST_CAROUSEL_FIELDS,
	},

	[SOCIAL_AD_TYPES.SNAPCHAT_IMAGE]: SNAPCHAT_IMAGE_FIELDS,
	[SOCIAL_AD_TYPES.SNAPCHAT_VIDEO]: SNAPCHAT_VIDEO_FIELDS,

	[SOCIAL_AD_TYPES.TIKTOK_VIDEO]: TIKTOK_VIDEO_FIELDS,
};

export default function getSocialFields(adType){
	return FIELDS_BY_ADTYPE[adType];
}
